const processEnv = process.env as any;

export const getMixpanelApiKey: string | undefined = processEnv.REACT_APP_MIXPANEL_API_KEY;
export const baseUrl: string | undefined = processEnv.REACT_APP_BASE_URL;
export const loginUrl: string | undefined = processEnv.REACT_APP_LOGIN_URL;
export const registrationUrl: string | undefined = processEnv.REACT_APP_REGISTRATION_URL;
export const refererDomain: string | undefined = processEnv.REACT_APP_REFERER_DOMAIN;
export const logrocketToken: string = setLogrocketToken();
export const mixpanelApiKey: string = setMixpanelApiKey();
export const SELF_SERVICE_API_URL: string | undefined = processEnv.REACT_APP_SELF_SERVICE_API_URL;

function setLogrocketToken(): string {
  const hostname: string = window.location.hostname;
  let logrocketToken: string = "";

  if (hostname === "registration-qa.verbit.co" || hostname === "registration.verbit.co" || hostname === "registration-staging.verbit.co") {
    logrocketToken = processEnv.REACT_APP_LOGROCKET_TOKEN_REGISTRATION;
  } else if (
    hostname === "signup-qa.verbit.co" ||
    hostname === "signup.verbit.co" ||
    hostname === "signup-en.verbit.co" ||
    hostname === "signup-us.verbit.co" ||
    hostname === "signup-staging.verbit.co"
  ) {
    logrocketToken = processEnv.REACT_APP_LOGROCKET_TOKEN;
  } else if (hostname === 'localhost') {
    logrocketToken = processEnv.REACT_APP_LOGROCKET_TOKEN_REGISTRATION;
  } else {
    console.error("Invalid domain:", hostname);
  }

  return logrocketToken;
}

function setMixpanelApiKey(): string {
  const hostname: string = window.location.hostname;
  let mixpanelApiKey: string = "";

  if (hostname === "registration-qa.verbit.co" || hostname === "registration-staging.verbit.co") {
    mixpanelApiKey = processEnv.REACT_APP_MIXPANEL_REGISTRATION_QA;
  } else if (hostname === "registration.verbit.co") {
    mixpanelApiKey = processEnv.REACT_APP_MIXPANEL_REGISTRATION_PROD;
  } else if (hostname === "signup-qa.verbit.co" || hostname === "signup.verbit.co" || hostname === "signup-staging.verbit.co") {
    mixpanelApiKey = processEnv.REACT_APP_MIXPANEL_API_KEY;
  } else if (hostname === 'localhost') {
    mixpanelApiKey = processEnv.REACT_APP_MIXPANEL_REGISTRATION_QA;
  } else {
    console.error("Invalid domain:", hostname);
  }

  return mixpanelApiKey;
}